import { createContext } from 'react';

/**
 * @constant  {React.Context<Auth>}
 */
export const AuthContext = createContext({});
